import type {
  Product,
  ProductEdge,
  Collection,
  CollectionConnection,
  CollectionEdge,
  Metafield,
  ProductConnection,
} from "@shopify/hydrogen-react/storefront-api-types";
import { query } from "gql-query-builder";

import { filterFields, imageFields, pageFields } from "./fields";
import { brandsMetafield, typeMetafield, membershipMetafield, tagMetafield } from "./metafields/collection-metafields";
import { commonProductFields } from "./product-gql";
import type { IProductMetafields } from "./product-gql";

export interface ICollectionMetafields {
  accessible_memberships?: Metafield;
}

/**
 * handle 이용하여 컬렉션 상품 목록 조회
 */

export interface ICollectionHandleQuery {
  collection: Collection &
    ICollectionMetafields & {
      pages: ProductConnection;
      products: ProductConnection & {
        edges: (ProductEdge & {
          node: Product & IProductMetafields;
        })[];
      };
    };
}

export const collectionHandleQuery = query(
  {
    operation: "collection",
    fields: [
      "id",
      "title",
      "description",
      {
        operation: "pages: products(first: 1)",
        fields: [{ edges: [{ node: ["id"] }] }],
        variables: {},
      },
      "handle",
      { image: imageFields },
      {
        operation: "products",
        fields: [
          {
            filters: filterFields,
            edges: [{ node: [...commonProductFields] }],
          },
          { pageInfo: pageFields },
        ],
        variables: {
          first: { type: "Int!" },
          after: { type: "String" },
          filters: { type: "[ProductFilter!]" },
          sortKey: { type: "ProductCollectionSortKeys!" },
          reverse: { type: "Boolean" },
        },
      },
      membershipMetafield,
    ],
    variables: { handle: { type: "String!" } },
  },
  undefined,
  { operationName: "CollectionHandle" },
);

/**
 * 컬렉션 목록 조회
 */
export interface ICollectionsEdgesNode extends Collection {
  brands?: Metafield;
  type?: Metafield;
  tag?: Metafield;
}

export interface ICollectionsQuery {
  collections: CollectionConnection & {
    edges: (CollectionEdge & {
      node: ICollectionsEdgesNode;
    })[];
  };
}

export const collectionsQuery = query(
  {
    operation: "collections(first: 200, sortKey: TITLE)",
    fields: [{ edges: [{ node: ["id", "title", "handle", brandsMetafield, typeMetafield, tagMetafield] }] }],
  },
  undefined,
  { operationName: "CollectionsTitle" },
);

/**
 * 컬렉션 filters(count) 조회
 */
export interface ICollectionsFiltersQuery {
  collections: CollectionConnection & {
    edges: (CollectionEdge & {
      node: Collection & {
        products: ProductConnection;
      };
    })[];
  };
}

export const collectionsFiltersQuery = query(
  {
    operation: "collections(first: 200)",
    fields: [
      {
        edges: [
          {
            node: [
              "id",
              "title",
              "handle",
              {
                operation: "products",
                fields: [{ filters: filterFields }],
                variables: {
                  first: { type: "Int!" },
                },
              },
            ],
          },
        ],
      },
    ],
  },
  undefined,
  { operationName: "CollectionsWithProducts" },
);
